import { useContext } from 'react';
import StreamContext from 'src/contexts/StreamContext';
const useStream = () => useContext(StreamContext);

export default useStream;
